import guidesFr from "./guides/guides.fr.json";
import guidesEn from "./guides/guides.en.json";
import guidesEs from "./guides/guides.es.json";
import listFr from "./guides/guides-list.fr.json";
import listEn from "./guides/guides-list.en.json";
import listEs from "./guides/guides-list.es.json";

export interface Feature {
  title: string;
  desc: string;
}

export interface GuideData {
  slug: string;
  title: string;
  metaDescription: string;
  intro: string;
  steps: { title: string; desc: string }[];
  features: Feature[];
  faq: { question: string; answer: string }[];
  ctaLabel: string;
  ctaHref: string;
}

export interface GuideListItem {
  slug: string;
  title: string;
  category: string;
}

type GuidesMap = Record<string, GuideData>;

const GUIDES_BY_LOCALE: Record<string, GuidesMap> = {
  fr: guidesFr as GuidesMap,
  en: guidesEn as GuidesMap,
  es: guidesEs as GuidesMap,
};

const LIST_BY_LOCALE: Record<string, GuideListItem[]> = {
  fr: listFr as GuideListItem[],
  en: listEn as GuideListItem[],
  es: listEs as GuideListItem[],
};

const norm = (lang?: string) => (lang || "fr").slice(0, 2);

/** Guides map (slug → GuideData) for the given locale, fallback FR. */
export function getGuides(lang?: string): GuidesMap {
  return GUIDES_BY_LOCALE[norm(lang)] ?? GUIDES_BY_LOCALE.fr;
}

/** Guide catalog list for the given locale, fallback FR. */
export function getGuideList(lang?: string): GuideListItem[] {
  return LIST_BY_LOCALE[norm(lang)] ?? LIST_BY_LOCALE.fr;
}
